import { AgreementsStorageService } from './agreements-storage.service';
import { AgreementStorageDataModel } from './agreement-storage-data.model';

export class AgreementBasicModel {
  public checked: boolean = false;
  public name: string;
  public selected: boolean;
  public priority: number;
  public expanded: boolean;
  public required: boolean;
  public storage: AgreementsStorageService;
  public status: AgreementStorageDataModel;

  constructor(storage: AgreementsStorageService) {
    this.storage = storage;
  }
}
